import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { BehaviorSubject, Observable } from "rxjs";
import { map } from "rxjs/operators";

@Injectable({ providedIn: "root" })
export class AuthfakeauthenticationService {
  private currentUserSubject!: BehaviorSubject<any>;
  public currentUser!: Observable<any>;

  constructor(private http: HttpClient) {
    if (
      typeof window !== "undefined" &&
      typeof sessionStorage !== "undefined"
    ) {
      this.currentUserSubject = new BehaviorSubject<any>(
        JSON.parse(sessionStorage.getItem("currentUser")!)
      );
      this.currentUser = this.currentUserSubject.asObservable();
    }
  }

  /**
   * current user
   */
  public get currentUserValue(): any {
    return this.currentUserSubject?.value;
  }

  /**
   * Performs the auth
   * @param email email of user
   * @param password password of user
   */
  login(email: string, password: string) {
    console.log("do login");
    return this.http.post<any>(`/users/authenticate`, { email, password }).pipe(
      map((user) => {
        // login successful if there's a jwt token in the response
        if (user && user.base64EncodedAuthenticationKey) {
          // store user details and jwt token in local storage to keep user logged in between page refreshes
          sessionStorage.setItem("toast", "true");
          sessionStorage.setItem(
            "auth-token",
            user.base64EncodedAuthenticationKey
          );
          console.log(JSON.stringify(user));
          sessionStorage.setItem("currentUser", JSON.stringify(user));
          this.currentUserSubject.next(user);
        }
        return user;
      })
    );
  }

  /**
   * Logout the user
   */
  logout() {
    // remove user from local storage to log user out
    sessionStorage.removeItem("currentUser");
    this.currentUserSubject.next(null!);
  }
}
